const steps = [
    {
        route: {name: 'game-goods'},
        title: 'Товары',
        description: 'Определитесь, с чего начнете. Прочитайте описание каждого и выбирайте тот, что кажется наиболее успешным.',
        media: {
            0: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-goods__grid',
                        radius: 32,
                        padding: [-50, 0, -30, 0],
                        height: 188
                    }
                ]
            },
            640: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-goods__grid',
                        radius: 32,
                        padding: [-20, 0, 0, 0],
                        height: 188
                    }
                ]
            },
            768: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-goods__grid',
                        radius: 94,
                        padding: [0, 0, 0, 0]
                    }
                ]
            }
        }
    },
    {
        route: {name: 'game-runtime'},
        action: 'addRegion',
        description: 'На этой части экрана вы будете видеть карту мира и сможете в реальном времени наблюдать, как ваши <a href="https://pikabu.ru/story/botromlovolu_imvidaloi_rok_m_sdey_nebraak_tam_5512520" target="_blank">товары на eBay</a> захватывают планету. Периодически на карте будут появляться бонусы. Успейте нажать на них, чтобы добавить баллы в копилку. Они вам понадобятся.',
        media: {
            0: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-map',
                        radius: 250,
                        padding: [30, -20, -30, -20]
                    }
                ]
            },
            640: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-map',
                        radius: 250,
                        padding: [20, 0, -70, 0]
                    }
                ]
            },
            768: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-map',
                        radius: 250,
                        padding: [20, 0, 20, 0]
                    }
                ]
            }
        }
    },
    {
        route: {name: 'game-runtime'},
        description: 'Чтобы открыть панель инструментов <a href="https://pikabu.ru/story/botromlovolu_imvidaloi_rok_m_sdey_nebraak_tam_5512520" target="_blank">продавца eBay</a>, нажмите «Улучшить объявление»',
        media: {
            0: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-regions__item',
                        radius: 42,
                        padding: [35, 5, 10, 5]
                    }
                ]
            },
            768: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-regions__item',
                        radius: 170,
                        padding: [20, 5, 20, 5]
                    }
                ]
            }
        }
    },
    {
        route: {name: 'game-runtime'},
        name: 'upgrades',
        timeout: 0,
        description: 'Успех любого дела в комплексном подходе. На панели есть кнопки с действиями. Они помогут прокачаться на <a href="https://pikabu.ru/story/botromlovolu_imvidaloi_rok_m_sdey_nebraak_tam_5512520" target="_blank">eBay</a>. Каждое действие стоит баллов и дает буст вашему бизнесу.',
        media: {
            0: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-regions__item',
                        radius: 14,
                        height: 185,
                        top: 245,
                        padding: [0, 10, 0, 5]
                    }
                ]
            },
            640: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-regions__item',
                        radius: 14,
                        height: 185,
                        top: 205,
                        padding: [0, 10, 0, 5]
                    }
                ]
            },
            768: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-upgrade__upgrades',
                        radius: 32,
                        padding: [20, 20, 10, 20]
                    }
                ]
            }
        }
    },
    {
        route: {name: 'game-runtime'},
        name: 'regions',
        description: 'Во время игры вы можете запустить товар в новом регионе и развивать свой бизнес на новой территории.',
        media: {
            768: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-regions__actions',
                        radius: 0,
                        padding: [0, 0, 0, 0]
                    }
                ]
            }
        }
    },
    {
        route: {name: 'game-runtime'},
        name: 'events',
        description: 'Помимо регулярных действий, которые вы будете планировать, нужно реагировать на спонтанные ситуации. Главное правило — быстро реагировать. <br /><br /> Следите за всплывающими окнами и не пропустите момент. Последствия будут негативно влиять на ваш бизнес.',
        media: {
            0: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-map',
                        radius: 250,
                        padding: [20, -20, -40, -20]
                    }
                ]
            },
            640: {
                rects: [
                    {
                        key: 'one',
                        element: '.section-map',
                        radius: 250,
                        padding: [20, -20, -120, -20]
                    }
                ]
            },
            768: {
                rects: [
                    {
                        key: 'one1',
                        element: '.section-map__event-fake--1',
                        radius: 100,
                        padding: [25, 25, 25, 25]
                    },
                    {
                        key: 'two1',
                        element: '.section-map__event-fake--2',
                        radius: 100,
                        padding: [25, 25, 25, 25]
                    },
                    {
                        key: 'three1',
                        element: '.section-map__event-fake--3',
                        radius: 100,
                        padding: [25, 25, 25, 25]
                    }
                ]
            }
        }
    },
    {
        route: {name: 'game-runtime'},
        description: 'Теперь вы знаете про все инструменты. Действуйте обдуманно, но быстро как настоящий завоеватель, и мировой рынок будет у ваших ног. Желаем удачи!',
        media: {
            768: {}
        }
    }
]

export default {
    namespaced: true,
    state: {
        steps,
        step: null
    },
    getters: {
        stepIndex (state) {
            return state.steps.findIndex(step => state.step === step)
        }
    },
    actions: {
        next ({commit, getters, state, dispatch}) {
            const stepIndex = getters.stepIndex
            const nextStepIndex = stepIndex === null ? 0 : stepIndex + 1
            const nextStep = state.steps[nextStepIndex]

            if (nextStep) {
                if (nextStep.action) {
                    dispatch(nextStep.action)
                }
                commit('step', nextStep)
            }
        },

        addRegion ({dispatch}) {
            dispatch('regions/createRegion', {
                regionId: 1,
                goodId: 1,
                silence: true
            }, {root: true})
        },

        reset ({commit}) {
            commit('reset')
        }
    },
    mutations: {
        step (state, step) {
            state.step = step
        },

        reset (state) {
            state.step = null
        }
    }
}
